// extracted by mini-css-extract-plugin
export var copyrightText = "footer-module--copyright-text--AO03W";
export var footer = "footer-module--footer--mZ7xv";
export var outboundLink = "footer-module--outbound-link--HWTEx";